(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["linenzo-home"] && !Shopify.designMode) return;
  try {
    
  const heroTemplate = document.querySelector('[data-desktop-hero]');
  if (heroTemplate) {
    const desktop = matchMedia('(min-width: 1024px) and (prefers-reduced-motion: no-preference)');
    const connection = navigator.connection;
    let video;
    const syncHero = () => {
      if (!desktop.matches || connection?.saveData) {
        if (video) {
          video.pause();
          video.removeAttribute('src');
          video.load();
          video.remove();
          video = null;
        }
        return;
      }
      if (video) return;
      video = heroTemplate.content.firstElementChild.cloneNode(true);
      video.muted = true;
      video.addEventListener('playing', () => video?.classList.add('is-playing'));
      video.src = video.dataset.src;
      heroTemplate.before(video);
      video.play().catch(() => {});
    };
    desktop.addEventListener('change', syncHero);
    connection?.addEventListener('change', syncHero);
    if (document.readyState === 'complete') syncHero();
    else window.addEventListener('load', syncHero, { once: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
